const popups = document.querySelectorAll('.block-pop-up');

if (popups.length > 0) {
	const openPopup = (popup) => {
		popup.classList.remove('block-pop-up--hidden');
		document.body.style.overflow = 'hidden';
	};

	const closePopup = (popup) => {
		popup.classList.add('block-pop-up--hidden');

		const anyOpen = document.querySelector(
			'.block-pop-up:not(.block-pop-up--hidden)'
		);
		if (!anyOpen) {
			document.body.style.overflow = '';
		}
	};

	// Trigger popup via href="#[scroll-id]" on any link/button
	document.addEventListener('click', (e) => {
		const link = e.target.closest('a[href^="#"]');
		if (!link) return;

		const targetId = link.getAttribute('href').slice(1);
		if (!targetId) return;

		const target = document.getElementById(targetId);
		if (target && target.classList.contains('block-pop-up')) {
			e.preventDefault();
			openPopup(target);
		}
	});

	popups.forEach((popup) => {
		const closeButton = popup.querySelector('.block-pop-up__close-button');

		if (closeButton) {
			closeButton.addEventListener('click', () => closePopup(popup));
		}

		// Close on backdrop click (click directly on the <dialog>, not the container)
		popup.addEventListener('click', (e) => {
			if (e.target === popup) {
				closePopup(popup);
			}
		});

		// Open Gated Content URL when the form inside THIS popup is submitted successfully
		window.addEventListener('form-submit-success', () => {
			if (!popup.querySelector('.gform_confirmation_wrapper')) return;

			const gatedContentURL = popup.dataset.gatedContentUrl;
			if (gatedContentURL) {
				window.open(gatedContentURL, '_blank', 'noopener,noreferrer');
			}
		});
	});

	// Close the topmost open popup on Escape
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;

		const activePopup = document.querySelector(
			'.block-pop-up:not(.block-pop-up--hidden)'
		);
		if (activePopup) {
			closePopup(activePopup);
		}
	});
}
